import {
  Dialog,
  DialogTitle,
  DialogActions,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import { message } from "antd";
import { showErrorToast } from "V2.0/utils";

export default function BulkCampaignDelete(props) {
  const { bulkCampaign, onClose, onBulkCampaignDelete } = props;

  function handleDelete() {
    const lifecycleCbs = {
      init: () => message.loading(`Deleting ${bulkCampaign.name}`),
      success: () => {
        message.destroy();
        message.success(`Deleted ${bulkCampaign.name}`);
        onClose();
      },
      error: (e) => {
        message.destroy();
        showErrorToast(e, `Failed to delete ${bulkCampaign.name}`);
      },
    };
    onBulkCampaignDelete(bulkCampaign._id, lifecycleCbs);
  }

  return (
    <Dialog open={true} onClose={onClose}>
      <DialogTitle>Delete {bulkCampaign.name} ?</DialogTitle>
      <DialogActions>
        <Button outline onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={handleDelete}>Delete</Button>
      </DialogActions>
    </Dialog>
  );
}
